import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const IdraulicoUrgenteRoma = () => {
  const handleCall = () => window.location.href = 'tel:3287686356';
  const handleWhatsApp = () => window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20idraulico%20urgente%20a%20Roma.', '_blank');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <Helmet>
        <title>Idraulico Urgente Roma H24 - Intervento in 60 Minuti | 328 768 6356</title>
        <meta name="description" content="Idraulico urgente Roma H24. Arrivo garantito in 60 minuti. Perdite, scarichi, allagamenti. Chiama subito: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/idraulico-urgente-roma`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-red-50 to-orange-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <div className="bg-red-600 text-white px-6 py-3 rounded-lg inline-block font-bold mb-4 text-xl animate-bounce">
                🚨 EMERGENZA IDRAULICA? CHIAMACI ORA!
              </div>
              
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
                Idraulico Urgente Roma
              </h1>
              
              <p className="text-3xl font-bold text-red-600 mb-6">
                ⚡ Arrivo GARANTITO in 60 minuti
              </p>
              
              <div className="bg-white p-8 rounded-lg shadow-2xl mb-8 border-4 border-orange-500">
                <p className="text-2xl font-bold text-gray-900 mb-6">EMERGENZE RISOLTE SUBITO:</p>
                <div className="grid md:grid-cols-2 gap-4 text-left text-lg">
                  <div className="flex items-center gap-3"><CheckCircle className="text-green-500 h-6 w-6 flex-shrink-0" /><span className="font-semibold">🚰 Perdite acqua gravi</span></div>
                  <div className="flex items-center gap-3"><CheckCircle className="text-green-500 h-6 w-6 flex-shrink-0" /><span className="font-semibold">💧 Allagamenti</span></div>
                  <div className="flex items-center gap-3"><CheckCircle className="text-green-500 h-6 w-6 flex-shrink-0" /><span className="font-semibold">🔧 Tubi scoppiati</span></div>
                  <div className="flex items-center gap-3"><CheckCircle className="text-green-500 h-6 w-6 flex-shrink-0" /><span className="font-semibold">🚽 WC intasato</span></div>
                  <div className="flex items-center gap-3"><CheckCircle className="text-green-500 h-6 w-6 flex-shrink-0" /><span className="font-semibold">🚿 Box doccia bloccato</span></div>
                  <div className="flex items-center gap-3"><CheckCircle className="text-green-500 h-6 w-6 flex-shrink-0" /><span className="font-semibold">🔥 Caldaia rotta</span></div>
                </div>
                
                <div className="mt-6 pt-6 border-t-2 border-gray-200">
                  <p className="text-xl font-bold text-orange-600">💰 PREZZI CHIARI: da 60€ • Paghi a lavoro fatto</p>
                </div>
              </div>
              
              <div className="flex flex-col gap-4 max-w-lg mx-auto mb-8">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-2xl px-12 py-10 font-bold shadow-2xl animate-pulse">
                  <MessageCircle className="mr-3 h-10 w-10" />
                  💬 WHATSAPP URGENTE
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-2xl px-10 py-9 font-bold shadow-xl">
                  <Phone className="mr-3 h-8 w-8" />
                  📞 CHIAMA: 328 768 6356
                </Button>
              </div>
              
              <div className="bg-blue-700 text-white p-6 rounded-lg">
                <p className="text-xl font-bold">
                  ✅ Operativi H24 in tutta Roma e provincia • Anche festivi e notturni
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default IdraulicoUrgenteRoma;
